export default {
	likedMe: "likedMe",
	viewedMe: "viewedMe",
	chat: "chat",
};
